import { render, staticRenderFns } from "./WaitPay.vue?vue&type=template&id=7c1d2fc7&scoped=true&"
import script from "./WaitPay.vue?vue&type=script&lang=js&"
export * from "./WaitPay.vue?vue&type=script&lang=js&"
import style0 from "./WaitPay.vue?vue&type=style&index=0&id=7c1d2fc7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1d2fc7",
  null
  
)

export default component.exports